import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FormEditorIcon, FormGalleryIcon } from '@dev/ee-components';
import { Grid } from '@material-ui/core';
import { OpenGallery, TemplateLoadStart } from '@/store/formCreator/actions';
import { ContentBox } from '@/assets/ContentBox';
import { TemplatesGallery } from '../../components/TemplatesGallery';


export const Step2EditContent = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const openFormTemplatesGallery = (): void => {
        dispatch(OpenGallery());
    };

    const openFormEditor = (): void => {
        dispatch(TemplateLoadStart());
    };

    return (
        <Grid container spacing={3}>
            <ContentBox
                id="form-creator-gallery-box"
                icon={<FormGalleryIcon/>}
                title={t('gallery')}
                description={t('choosefromgallery')}
                onBoxClick={openFormTemplatesGallery}
            />
            <ContentBox
                id="form-creator-scratch-box"
                icon={<FormEditorIcon/>}
                title={t('startfromscratch')}
                description={t('useformdesigner')}
                onBoxClick={openFormEditor}
            />
            <TemplatesGallery />
        </Grid>
    );
};
